<template>
  <div>
    <nav class="top-bar" style="height: 70px; width: 100%">
      <div class="nav-wrapper">
        <div v-show="employee" class="burger-btn" @click="visibleLeft = true">
          <i class="pi pi-align-justify"></i>
        </div>
        <div class="logo-container" @click="home">
          <img class="logo" src="../../assets/VanBerlo_logo_dark-grey_RGB_APPLICATIONS.png" />
        </div>
        <div v-show="employee" class="bell-btn">
          <i
            v-bind:class="{
              hasBadge: hasBadge,
            }"
            class="pi pi-bell"
            style="font-size: 35px"
            @click="toggle"
          ></i>
        </div>
      </div>
    </nav>
    <OverlayPanel ref="op" :showCloseIcon="false">
      <span v-if="notifications.length === 0" style="font-family: italian">{{
        $t("NavBar.NoNotifications")
      }}</span>
      <ul v-if="notifications.length > 0" style="list-style: none">
        <li v-for="item in notifications" :key="item.id">
          <router-link :to="{ name: 'notifications' }">
            {{ item.text }}
          </router-link>
        </li>
      </ul>
    </OverlayPanel>
    <Sidebar
      ref="sb"
      :visible.sync="visibleLeft"
      :baseZIndex="999999"
      :style="{ width: '900px;' }"
    >
      <div v-if="employee">
        <ul
          class="sidebar-menu"
          style="text-align: left; list-style: none; padding: 0"
        >
          <li><i class="pi pi-user"></i>{{ employee.name }}</li>
          <li>
            <i class="pi pi-envelope"></i
            >{{ employee.employeeEmail | formatPhoneEmail }}
          </li>
          <li>
            <i class="pi pi-phone"></i
            >{{ employee.employeePhone | formatPhoneEmail }}
          </li>
          <li @click="goToNotifications()">
            <i class="pi pi-bell"></i>{{ $t("NavBar.Notifications") }}
          </li>
          <li @click="showManualBox = !showManualBox">
            <i class="pi pi-file"></i>{{ $t("NavBar.Manual") }}
            <i v-show="showManualBox" class="pi pi-chevron-down"></i>
            <i v-show="!showManualBox" class="pi pi-chevron-right"></i>
          </li>
          <li style = "margin-left: 20px" v-if="showManualBox" @click="getManual('NL')">
            <i class="pi pi-file"></i>{{ $t("NavBar.Manual") }} NL
          </li> 
          <li style = "margin-left: 20px" v-if="showManualBox" @click="getManual('EN')">
            <i class="pi pi-file"></i>{{ $t("NavBar.Manual") }} EN
          </li>
          <li @click="showSettingsBox = !showSettingsBox">
            <i class="pi pi-cog"></i>{{ $t("NavBar.Settings") }}
            <i v-show="showSettingsBox" class="pi pi-chevron-down"></i>
            <i v-show="!showSettingsBox" class="pi pi-chevron-right"></i>
          </li>
          <li @click="openBugReport()">
            <i class="pi pi-flag-fill"></i>Bug report
          </li>
          <li @click="logout()" style ="position:absolute; bottom:25px;">
            <i class="pi pi-sign-out" ></i>{{ $t("NavBar.SignOut") }}
          </li>
        </ul>
        <div v-if="showSettingsBox">
          <EnableMidnightOption />
        </div>
        <div style="position:absolute; bottom:5px; left:0; right:0;">
          <Version />
        </div>
      </div>
    </Sidebar>
      <BugReport @close-modal="showBugReportModal=false" v-show="showBugReportModal"></BugReport>
  </div>

</template>

<script>
import LocalStorageService from "../../services/LocalStorageService";
import EnableMidnightOption from "../common/EnableMidnightOption";
import Version from "../Version";
import NotificationService from "../../services/NotificationService";
import FileService from "../../services/FileService";
import BugReport from "@/components/common/BugReport";
import moment from "moment";

export default {
  name: "Navbar",
  localStorageService: null,
  notificationService: null,
  fileService: null,
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    },
  },
  components: {
    EnableMidnightOption,
    Version,
    BugReport,
  },
  data() {
    return {
      visibleLeft: false,
      employee: null,
      showSettingsBox: false,
      showManualBox: false,
      notifications: [],
      hasBadge: false,
      showBugReportModal: false,
      moment: moment
    };
  },
  created() {
    this.localStorageService = new LocalStorageService();
    this.notificationService = new NotificationService();
    this.fileService = new FileService();
  },
  mounted() {
    this.employee = this.localStorageService.getCurrentEmployee();
    if (this.employee) {
      this.getUnSeenNotifications();
    }
  },
  watch: {
    loggedIn: function (n) {
      if (n) this.employee = this.localStorageService.getCurrentEmployee();
      else {
        this.employee = null;
      }
    },
  },
  methods: {
    click: function () {
      this.$router
        .push({
          name: "employee-login",
        })
        .catch(() => {});
    },
    toggle(event) {
      this.$refs.op.toggle(event);
      if (this.hasBadge && this.notifications) {
        const notificationIds = this.notifications.map((s) => s.id);
        this.notificationService.seenNotifications(notificationIds);
      }
      this.hasBadge = false;
    },
    logout() {
      this.visibleLeft = false;
      this.employee = null;
      this.$root.$emit("onLogin", false);
      setTimeout(() => {
        this.localStorageService.clear();
        this.$router
          .push({
            name: "employee-login",
          })
          .catch(() => {});
      }, 300);
    },
    home(event) {
      event.preventDefault();
      const loggedInEmployee = this.localStorageService.getCurrentEmployee();
      if (loggedInEmployee) {
        this.getUnSeenNotifications();
        return this.$router.push({ name: "work-day", query: { workDate: this.getCurrentDate() } })
          .catch(() => {});
      }
      return this.$router
        .push({
          name: "employee-login",
        })
        .catch(() => {});
    },
    getUnSeenNotifications() {
      this.notificationService.getUnSeenNotifications().then((result) => {
        this.notifications = result.data;
        this.hasBadge = this.notifications.length > 0;
      });
    },
    getManual(lang) {
      var windowReference = window.open("about:blank","_blank");
      this.fileService.getManualUrl(lang).then((result) => {
        windowReference.location = result.data;
      });
    },
    openBugReport() {
      this.showBugReportModal = true;
      this.visibleLeft = false;
    },
    goToNotifications() {
      this.$router
        .push({
          name: "notifications",
        })
        .catch(() => {});
    },
    getCurrentDate(){
      let currentDate = new Date().setHours(0, 0, 0, 0);
      currentDate = moment(currentDate).toISOString();
      return currentDate;
    }
  },
};
</script>

<style scoped>
.logo {
  height: 68px;
  z-index: 10;
}

.top-bar {
  position: relative;
  top: 0;
  z-index: 1000;
  height: 70px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-bottom: 1px solid #1f2a44;
  -webkit-filter: drop-shadow(0 1px 5px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 5px rgba(0, 0, 0, 0.2));
  background: #fff;
}

.logo-bg-shape {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 670px;
  height: 70px;
  z-index: 9;
}

.nav-wrapper {
  display: flex;
  align-items: center;
}

.bell-btn {
  position: absolute;
  right: 18px;
  z-index: 999;
}

.logo-container {
  position: absolute;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: center;
}

.burger-btn {
  padding-left: 18px;
  z-index: 999;
}

.pi {
  font-size: 25px;
  margin-right: 5px;
}

.sidebar-menu {
  margin-top: 20px;
}

.sidebar-menu li {
  padding: 13px 30px;
  display: flex;
  align-items: center;
}

.p-overlaypanel:before {
  left: 7.75em;
}

.p-overlaypanel:after {
  left: 7.75em;
}
</style>
